import { render } from "./CampagnesOverview.vue?vue&type=template&id=2c57ec8c&scoped=true"
import script from "./CampagnesOverview.vue?vue&type=script&lang=js"
export * from "./CampagnesOverview.vue?vue&type=script&lang=js"

import "./CampagnesOverview.vue?vue&type=style&index=0&id=2c57ec8c&scoped=true&lang=css"

import exportComponent from "/data/gitlab-runner/builds/hunterretail/narrowcastingrpi/narrowcastingwebapp/narrowcasting_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c57ec8c"]])

export default __exports__